const importAll = context => {
  const map = {}

  for (const key of context.keys()) {
    const config = context(key)
    Object.assign(map, config.default)
  }

  return map
}

const routerMaps = require.context('./views', false, /\.js$/)
const map = importAll(routerMaps)

export default map
